import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { FETCH_ITEM, SUBMIT_REVIEW } from './types';

export const fetchItem = createTaskAction(FETCH_ITEM);

export const submitReview = createTaskAction(SUBMIT_REVIEW);
